<template>
  <Tooltip
    class="iv-tooltip"
    :disabled="tooltipDisable"
    :content="content"
    placement="top"
    :delay="500">
    <DatePicker
      ref="datePicker"
      v-model="val"
      confirm
      style="width: 100%"
      :type="props.type || 'datetimerange'"
      placeholder="请选择"
      v-bind="props"
      @on-ok="onOk"
      @on-clear="onClear"/>
  </Tooltip>
</template>

<script>
import { timeFormat } from '@/utils'
const DEFAULT_FORMATS = {
  date: 'yyyy-MM-dd',
  month: 'yyyy-MM',
  year: 'yyyy',
  datetime: 'yyyy-MM-dd HH:mm:ss',
  time: 'HH:mm:ss',
  timerange: 'HH:mm:ss',
  daterange: 'yyyy-MM-dd',
  datetimerange: 'yyyy-MM-dd HH:mm:ss'
}
export default {
  name: 'datePicker',
  props: {
    value: {
      default: ''
    },
    props: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    tooltipDisable () {
      return !(!!this.val[0] && !!this.val[0])
    },
    content () {
      if (Array.isArray(this.val)) {
        let [to, from] = this.val
        if (!to || !from) return ''
        const format = DEFAULT_FORMATS[this.props.type || 'datetimerange']
        to = timeFormat(to, this.props.format || format)
        from = timeFormat(from, this.props.format || format)
        return `${to} 至 ${from}`
      } else {
        const format = DEFAULT_FORMATS[this.props.type || 'datetimerange']
        return timeFormat(this.val, this.props.format || format)
      }
    }
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    setVal (newVal) {
      this.val = newVal
    },
    onOk () {
      this.$emit('on-ok', this.val)
    },
    onClear () {
      this.$emit('on-clear', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/base/variable.scss';
  .iv-tooltip {
    width: 100%;
    /deep/ .ivu-tooltip-inner {
      white-space: normal;
      max-width: 400px;
    }
    /deep/ .ivu-tooltip-rel {
      width: 100%;
    }
  }
</style>
